export const videos = [
  {
    id: 1,
    title: '流浪地球2',
    category: 'dianying',
    categoryName: '电影',
    cover: 'https://readdy.ai/api/search-image?query=A%20cinematic%20sci-fi%20movie%20poster%20with%20astronaut%20on%20distant%20exoplanet%20with%20massive%20planet%20in%20sky%2C%20dramatic%20orange%20and%20blue%20nebula%20colors%2C%20epic%20space%20adventure%20atmosphere%2C%20Chinese%20film%20aesthetic%2C%20clean%20composition%20with%20soft%20ambient%20lighting%2C%20movie%20poster%20style&width=800&height=450&seq=video-cover-001&orientation=landscape',
    rating: 8.3,
    year: 2023,
    duration: '173分钟',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。',
    tags: ['科幻', '冒险', '灾难'],
    source: '西瓜视频免费',
    sourceUrl: '#',
    updateTime: '2024-07-15',
    isHot: true,
    isNew: false,
    views: '1280万',
  },
  {
    id: 2,
    title: '狂飙',
    category: 'dianshiju',
    categoryName: '电视剧',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20crime%20drama%20TV%20series%20poster%2C%20two%20men%20in%20dark%20suits%20standing%20back%20to%20back%20on%20city%20street%20at%20night%2C%20rainy%20atmosphere%2C%20neo-noir%20lighting%20with%20warm%20red%20and%20cool%20blue%20contrast%2C%20suspenseful%20mood%2C%20film%20poster%20aesthetic%20with%20Chinese%20text%20space&width=800&height=450&seq=video-cover-002&orientation=landscape',
    rating: 9.0,
    year: 2023,
    duration: '39集',
    description: '以一线刑警安欣为代表的正义力量，与黑恶势力展开的长达二十年的生死较量，通过群像叙事展现扫黑行动中的黑白较量和复杂人性。',
    tags: ['犯罪', '悬疑', '剧情'],
    source: '91在线视频',
    sourceUrl: '#',
    updateTime: '2024-07-20',
    isHot: true,
    isNew: true,
    views: '3580万',
  },
  {
    id: 3,
    title: '长安三万里',
    category: 'dongman',
    categoryName: '动漫',
    cover: 'https://readdy.ai/api/search-image?query=Animated%20film%20poster%20showing%20ancient%20Chinese%20Tang%20Dynasty%20warrior%20poet%20on%20horseback%20galloping%20through%20golden%20wheat%20field%20under%20dramatic%20sunset%20sky%2C%20traditional%20Chinese%20ink%20painting%20style%20blended%20with%203D%20animation%2C%20warm%20golden%20and%20crimson%20tones&width=800&height=450&seq=video-cover-003&orientation=landscape',
    rating: 8.2,
    year: 2023,
    duration: '168分钟',
    description: '安史之乱爆发后数年，吐蕃大军攻打西南。大唐节度使高适交战不利，长安岌岌可危。困守孤城的高适向监军太监回忆起自己与李白的一生往事。',
    tags: ['动画', '历史', '传记'],
    source: '小蓝视频',
    sourceUrl: '#',
    updateTime: '2024-06-28',
    isHot: true,
    isNew: false,
    views: '960万',
  },
  {
    id: 4,
    title: '封神第一部：朝歌风云',
    category: 'dianying',
    categoryName: '电影',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20film%20poster%2C%20ancient%20Chinese%20general%20in%20ornate%20bronze%20armor%20riding%20a%20white%20horse%20with%20flowing%20red%20cape%2C%20dramatic%20stormy%20sky%20with%20lightning%2C%20mythological%20Chinese%20aesthetic%2C%20cinematic%20epic%20scale%2C%20warm%20gold%20and%20crimson%20color%20palette&width=800&height=450&seq=video-cover-004&orientation=landscape',
    rating: 8.0,
    year: 2023,
    duration: '148分钟',
    description: '商王殷寿与狐妖妲己勾结，暴虐无道，引发天谴。昆仑仙人姜子牙携"封神榜"下山，寻找天下共主，以救苍生。西伯侯之子姬发逐渐发现殷寿的本来面目，反出朝歌。',
    tags: ['奇幻', '动作', '史诗'],
    source: '西瓜视频免费',
    sourceUrl: '#',
    updateTime: '2024-07-10',
    isHot: true,
    isNew: false,
    views: '2150万',
  },
  {
    id: 5,
    title: '乘风破浪的姐姐 第四季',
    category: 'zongyi',
    categoryName: '综艺',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20group%20of%20elegant%20women%20in%20colorful%20stunning%20stage%20costumes%20on%20a%20glamorous%20stage%20with%20sparkling%20lights%2C%20energetic%20performance%20atmosphere%2C%20pink%20and%20gold%20stage%20lighting%2C%20entertainment%20show%20aesthetic&width=800&height=450&seq=video-cover-005&orientation=landscape',
    rating: 7.8,
    year: 2023,
    duration: '12期',
    description: '节目将关注30+女性成长、鼓励女性勇敢追梦的励志精神。多位各具风格的姐姐们重新出发，通过舞台竞演展现独立女性的光彩。',
    tags: ['真人秀', '音乐', '竞演'],
    source: '久久视频',
    sourceUrl: '#',
    updateTime: '2024-07-18',
    isHot: false,
    isNew: true,
    views: '1860万',
  },
  {
    id: 6,
    title: '三体',
    category: 'dianshiju',
    categoryName: '电视剧',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20drama%20poster%2C%20mysterious%20cosmic%20background%20with%20three%20suns%20and%20strange%20planet%2C%20silhouette%20of%20a%20person%20looking%20up%20at%20the%20sky%2C%20dark%20and%20mysterious%20atmosphere%2C%20complex%20cosmic%20patterns%2C%20scientific%20research%20facility%20in%20foreground%2C%20purple%20and%20deep%20blue%20cosmic%20tones&width=800&height=450&seq=video-cover-006&orientation=landscape',
    rating: 8.7,
    year: 2023,
    duration: '30集',
    description: '21世纪初，地球基础科学出现了异常的扰动。纳米科学家汪淼进入神秘的网络游戏《三体》，开始逐步逼近这个世界的真相。',
    tags: ['科幻', '悬疑', '剧情'],
    source: '小蓝视频',
    sourceUrl: '#',
    updateTime: '2024-07-22',
    isHot: true,
    isNew: true,
    views: '2980万',
  },
  {
    id: 7,
    title: '满江红',
    category: 'dianying',
    categoryName: '电影',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20suspense%20film%20poster%2C%20ancient%20Chinese%20courtyard%20at%20night%20with%20lanterns%2C%20soldiers%20in%20Song%20Dynasty%20armor%20marching%20through%20narrow%20alleyway%2C%20dark%20and%20tense%20atmosphere%2C%20deep%20red%20lanterns%20contrasting%20with%20dark%20blue%20night%2C%20cinematic%20film%20noir%20style&width=800&height=450&seq=video-cover-007&orientation=landscape',
    rating: 8.5,
    year: 2023,
    duration: '159分钟',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。一个小兵与亲兵营副统领机缘巧合被裹挟进这场巨大阴谋之中。',
    tags: ['悬疑', '喜剧', '历史'],
    source: '91在线视频',
    sourceUrl: '#',
    updateTime: '2024-06-15',
    isHot: true,
    isNew: false,
    views: '4560万',
  },
  {
    id: 8,
    title: '地球脉动 第三季',
    category: 'jilupian',
    categoryName: '纪录片',
    cover: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%2C%20breathtaking%20aerial%20view%20of%20diverse%20wildlife%20across%20savanna%20ocean%20and%20mountains%2C%20elephant%20herd%20walking%20across%20golden%20plains%2C%20whale%20breaching%20in%20ocean%2C%20eagle%20soaring%20over%20mountains%2C%20vibrant%20natural%20colors%2C%20BBC%20documentary%20style&width=800&height=450&seq=video-cover-008&orientation=landscape',
    rating: 9.7,
    year: 2023,
    duration: '8集',
    description: '从海洋深处到最偏远的丛林，本季将带领观众踏上一段非凡的旅程，以前所未有的方式探索我们星球上最偏远、最壮丽的栖息地。',
    tags: ['自然', '动物', '探索'],
    source: '久久视频',
    sourceUrl: '#',
    updateTime: '2024-07-05',
    isHot: false,
    isNew: true,
    views: '620万',
  },
  {
    id: 9,
    title: '绝世武魂',
    category: 'dongman',
    categoryName: '动漫',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20donghua%20poster%2C%20young%20martial%20arts%20master%20with%20glowing%20spiritual%20energy%20flying%20through%20ancient%20Chinese%20mountain%20landscape%2C%20flowing%20robes%20and%20sword%2C%20mystical%20golden%20and%20crimson%20energy%20effects%2C%20cultivation%20fantasy%20theme%2C%20dynamic%20composition&width=800&height=450&seq=video-cover-009&orientation=landscape',
    rating: 7.5,
    year: 2023,
    duration: '120集',
    description: '少年陈枫意外获得上古传承，踏上武道巅峰之路。在这个弱肉强食的玄幻世界中，他以绝世武魂为根基，一路披荆斩棘，成就无上传说。',
    tags: ['玄幻', '热血', '国漫'],
    source: '西瓜视频免费',
    sourceUrl: '#',
    updateTime: '2024-07-25',
    isHot: false,
    isNew: true,
    views: '850万',
  },
  {
    id: 10,
    title: 'NBA季后赛 2024',
    category: 'tiyu',
    categoryName: '体育',
    cover: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20playoff%20poster%2C%20professional%20basketball%20player%20dunking%20ball%20in%20packed%20arena%20with%20dramatic%20spotlight%2C%20intense%20sports%20action%20moment%2C%20confetti%20falling%2C%20championship%20atmosphere%2C%20vibrant%20arena%20lights%2C%20sports%20photography%20style&width=800&height=450&seq=video-cover-010&orientation=landscape',
    rating: 9.2,
    year: 2024,
    duration: '多场次',
    description: '2024年NBA季后赛全程高能！东西部各路豪强激烈对决，詹姆斯、库里、杜兰特等超级巨星季后赛巅峰表现，冠军之路全程记录。',
    tags: ['篮球', 'NBA', '竞技'],
    source: '小蓝视频',
    sourceUrl: '#',
    updateTime: '2024-07-28',
    isHot: true,
    isNew: true,
    views: '3520万',
  },
  {
    id: 11,
    title: '唐朝诡事录之西行',
    category: 'dianshiju',
    categoryName: '电视剧',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20period%20mystery%20drama%20poster%2C%20Tang%20Dynasty%20detectives%20in%20traditional%20robes%20investigating%20in%20ancient%20desert%20town%20at%20sunset%2C%20mysterious%20and%20suspenseful%20mood%2C%20warm%20desert%20golden%20light%2C%20Western%20Regions%20Silk%20Road%20aesthetic%2C%20period%20drama%20film%20style&width=800&height=450&seq=video-cover-011&orientation=landscape',
    rating: 8.6,
    year: 2024,
    duration: '40集',
    description: '卢凌风、苏无名等一行人离开长安一路西行，前往西域途中遭遇多起离奇诡异的案件。在大漠孤烟之中，他们揭开一层层迷雾。',
    tags: ['悬疑', '古装', '探案'],
    source: '91在线视频',
    sourceUrl: '#',
    updateTime: '2024-07-30',
    isHot: true,
    isNew: true,
    views: '1680万',
  },
  {
    id: 12,
    title: '热辣滚烫',
    category: 'dianying',
    categoryName: '电影',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20film%20poster%2C%20a%20determined%20woman%20boxing%20in%20a%20gym%20with%20sweat%20and%20intense%20expression%2C%20warm%20motivational%20atmosphere%2C%20boxing%20ring%20background%20with%20dramatic%20overhead%20lighting%2C%20red%20and%20gold%20tones%2C%20inspiring%20sports%20drama%20aesthetic&width=800&height=450&seq=video-cover-012&orientation=landscape',
    rating: 7.9,
    year: 2024,
    duration: '129分钟',
    description: '乐莹是一个善良的女孩，但在生活中处处碰壁。在人生最灰暗的时刻，她偶然接触到拳击运动，从此踏上了一段热辣滚烫的人生逆袭之路。',
    tags: ['喜剧', '运动', '励志'],
    source: '久久视频',
    sourceUrl: '#',
    updateTime: '2024-07-12',
    isHot: true,
    isNew: false,
    views: '5230万',
  },
  {
    id: 13,
    title: '斗罗大陆2：绝世唐门',
    category: 'dongman',
    categoryName: '动漫',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20anime%20poster%2C%20young%20boy%20with%20spirit%20ring%20glowing%20around%20him%20in%20fantasy%20academy%20setting%2C%20magical%20martial%20arts%20cultivation%20theme%2C%20blue%20and%20gold%20spirit%20energy%20effects%2C%20fantasy%20school%20architecture%20background%2C%20dynamic%20action%20pose%2C%20vibrant%20anime%20style&width=800&height=450&seq=video-cover-013&orientation=landscape',
    rating: 8.1,
    year: 2024,
    duration: '52集',
    description: '霍雨浩自幼灵眸武魂觉醒，进入史莱克学院学习。在绝世唐门的传承中，他一步步成长为强大的魂师，与伙伴们并肩作战，守护大陆和平。',
    tags: ['玄幻', '热血', '国漫'],
    source: '西瓜视频免费',
    sourceUrl: '#',
    updateTime: '2024-07-26',
    isHot: false,
    isNew: true,
    views: '1350万',
  },
  {
    id: 14,
    title: '奔跑吧 第12季',
    category: 'zongyi',
    categoryName: '综艺',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20running%20man%20show%20poster%2C%20group%20of%20celebrities%20running%20and%20laughing%20on%20colorful%20outdoor%20set%2C%20energetic%20and%20fun%20atmosphere%2C%20bright%20sunny%20day%2C%20game%20show%20elements%2C%20vibrant%20rainbow%20colors%2C%20entertainment%20show%20aesthetic&width=800&height=450&seq=video-cover-014&orientation=landscape',
    rating: 7.3,
    year: 2024,
    duration: '12期',
    description: '本季跑男团继续带来爆笑游戏和激烈对决。新老成员齐聚，在城市与自然之间展开一系列令人捧腹的挑战，为观众带来无尽欢乐。',
    tags: ['真人秀', '游戏', '搞笑'],
    source: '小蓝视频',
    sourceUrl: '#',
    updateTime: '2024-07-19',
    isHot: false,
    isNew: false,
    views: '980万',
  },
  {
    id: 15,
    title: '飞驰人生2',
    category: 'dianying',
    categoryName: '电影',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20movie%20poster%2C%20a%20rally%20race%20car%20drifting%20on%20dusty%20mountain%20road%20at%20sunset%2C%20dramatic%20action%20shot%20with%20motion%20blur%2C%20warm%20golden%20hour%20lighting%2C%20adventurous%20spirit%2C%20cinematic%20car%20racing%20aesthetic&width=800&height=450&seq=video-cover-015&orientation=landscape',
    rating: 7.8,
    year: 2024,
    duration: '121分钟',
    description: '曾经叱咤赛车界的冠军车手张驰，沦落为驾校教练。在昔日队友的邀请下，他再次踏上巴音布鲁克拉力赛的征程，这一次他要证明自己宝刀未老。',
    tags: ['喜剧', '运动', '赛车'],
    source: '91在线视频',
    sourceUrl: '#',
    updateTime: '2024-06-20',
    isHot: false,
    isNew: false,
    views: '2890万',
  },
  {
    id: 16,
    title: '大国工匠',
    category: 'jilupian',
    categoryName: '纪录片',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20documentary%20poster%2C%20skilled%20craftsman%20carefully%20working%20on%20intricate%20metalwork%20in%20traditional%20Chinese%20workshop%2C%20warm%20forge%20light%2C%20hands%20creating%20art%2C%20cultural%20heritage%20theme%2C%20authentic%20traditional%20craftsmanship%2C%20golden%20glowing%20metal%20and%20wood%20textures&width=800&height=450&seq=video-cover-016&orientation=landscape',
    rating: 8.9,
    year: 2024,
    duration: '10集',
    description: '聚焦中国各行各业的顶尖工匠大师，展现他们精益求精的工匠精神和令人叹为观止的技艺水平，从传统手工艺到现代制造业的传奇故事。',
    tags: ['人文', '工匠', '传承'],
    source: '久久视频',
    sourceUrl: '#',
    updateTime: '2024-07-08',
    isHot: false,
    isNew: false,
    views: '430万',
  },
  {
    id: 17,
    title: '偷偷藏不住',
    category: 'duanju',
    categoryName: '短剧',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20youth%20romance%20short%20drama%20poster%2C%20young%20couple%20sitting%20on%20campus%20bench%20under%20cherry%20blossom%20tree%2C%20sweet%20and%20warm%20spring%20atmosphere%2C%20soft%20pink%20and%20white%20petals%2C%20youthful%20romantic%20mood%2C%20school%20uniforms%2C%20fresh%20and%20pure%20aesthetic&width=800&height=450&seq=video-cover-017&orientation=landscape',
    rating: 7.6,
    year: 2024,
    duration: '25集',
    description: '桑稚高中时期被老师频繁请家长，为了解决麻烦，她决定找哥哥顶包。当兄妹俩见面后就过上了斗智斗勇的生活，而一段暗恋也悄然生长。',
    tags: ['爱情', '校园', '甜宠'],
    source: '西瓜视频免费',
    sourceUrl: '#',
    updateTime: '2024-07-29',
    isHot: false,
    isNew: true,
    views: '760万',
  },
  {
    id: 18,
    title: '世界杯预选赛 亚洲区',
    category: 'tiyu',
    categoryName: '体育',
    cover: 'https://readdy.ai/api/search-image?query=Football%20soccer%20World%20Cup%20qualifier%20match%20poster%2C%20Chinese%20national%20team%20players%20celebrating%20goal%20in%20packed%20stadium%2C%20dramatic%20stadium%20lights%2C%20green%20pitch%20under%20night%20sky%2C%20passionate%20fans%20in%20red%2C%20international%20competition%20atmosphere%2C%20sports%20photography&width=800&height=450&seq=video-cover-018&orientation=landscape',
    rating: 8.5,
    year: 2024,
    duration: '多场次',
    description: '2026世界杯亚洲区预选赛激战正酣！中国队全力冲击世界杯门票，每一场比赛都牵动亿万球迷的心，全程高清直播不容错过。',
    tags: ['足球', '世界杯', '国足'],
    source: '小蓝视频',
    sourceUrl: '#',
    updateTime: '2024-08-01',
    isHot: true,
    isNew: true,
    views: '6120万',
  },
];